import React from "react";
import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ReviewProgress({
  title,
  description,
  titleId,
  headingAs: Heading = "h2",
  className = "",
  progressLabel,
  progressText,
}) {
  const { t } = useTranslation();
  const resolvedProgressLabel =
    progressLabel || t("kyc.verificationLoading.progressLabel");
  const resolvedProgressText =
    progressText || t("kyc.verificationLoading.progressText");

  return (
    <div
      className={`review-progress w-full max-w-sm text-center ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <span className="relative mx-auto flex size-16 items-center justify-center rounded-2xl bg-teal-50 text-teal-700 ring-1 ring-teal-100">
        <span
          className="absolute inset-1 rounded-xl border border-teal-200/80"
          aria-hidden="true"
        />
        <ShieldCheck className="relative size-7" aria-hidden="true" />
      </span>

      <Heading
        id={titleId}
        className="mt-6 text-xl font-semibold leading-tight tracking-[-0.025em] text-slate-950 sm:text-2xl"
      >
        {title}
      </Heading>
      <p className="mt-2 text-sm leading-6 text-slate-500">{description}</p>

      <div
        className="kyc-review-progress-track mx-auto mt-6 h-2 w-full overflow-hidden rounded-full bg-slate-200"
        role="progressbar"
        aria-label={resolvedProgressLabel}
        aria-valuetext={resolvedProgressText}
      >
        <span className="kyc-review-progress-bar block h-full w-2/5 rounded-full bg-gradient-to-r from-teal-600 via-teal-500 to-cyan-400" />
      </div>
      <p className="mt-2 text-xs font-medium text-slate-500">
        {resolvedProgressText}
      </p>
    </div>
  );
}
